var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DashboardWidget", {
    attrs: { id: "calendar_panel", items: _vm.items, loading: _vm.loading },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var item = ref.item
          return [
            item.isEmptyItem
              ? _c("EmptyContent", {
                  staticClass: "half-screen",
                  attrs: {
                    id: "calendar-widget-empty-content",
                    icon: "icon-checkmark"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "desc",
                        fn: function() {
                          return [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.t("calendar", "No more events today")
                                ) +
                                "\n\t\t\t"
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              : _c("DashboardWidgetItem", {
                  attrs: {
                    "main-text": item.mainText,
                    "sub-text": item.subText,
                    "target-url": item.targetUrl
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "avatar",
                        fn: function() {
                          return [
                            item.componentName === "VEVENT"
                              ? _c("div", {
                                  staticClass: "calendar-dot",
                                  style: {
                                    "background-color": item.calendarColor
                                  },
                                  attrs: { title: item.calendarDisplayName }
                                })
                              : _c("div", {
                                  staticClass: "vtodo-checkbox",
                                  style: { color: item.calendarColor },
                                  attrs: { title: item.calendarDisplayName }
                                })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
          ]
        }
      },
      {
        key: "empty-content",
        fn: function() {
          return [
            _c("EmptyContent", {
              attrs: {
                id: "calendar-widget-empty-content",
                icon: "icon-calendar-dark"
              },
              scopedSlots: _vm._u([
                {
                  key: "desc",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.t("calendar", "No upcoming events")) +
                          "\n\t\t\t\t"
                      ),
                      _c("div", { staticClass: "empty-label" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button",
                            attrs: { href: _vm.clickStartNew }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.t("calendar", "Create a new event")
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }